// Professor Dashboard Constants

export const RANKING_LEVELS = ["Branco", "Amarelo", "Laranja", "Verde", "Azul", "Vermelho", "Preto"];

export const RANKING_COLORS = {
  "Branco": "bg-gray-100 text-gray-700 border-gray-300",
  "Amarelo": "bg-yellow-100 text-yellow-800 border-yellow-400",
  "Laranja": "bg-orange-100 text-orange-800 border-orange-400",
  "Verde": "bg-green-100 text-green-800 border-green-400",
  "Azul": "bg-blue-100 text-blue-800 border-blue-400",
  "Vermelho": "bg-red-100 text-red-800 border-red-400",
  "Preto": "bg-gray-900 text-white border-gray-900",
};

export const getCategoryLabel = (cat) => {
  if (cat === "surf") return "Surf";
  if (cat === "bodyboard") return "Bodyboard";
  return "Surf & Bodyboard";
};
